/* eslint-disable no-shadow */
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { http } from "@/api/index";
import {
	CloseDiagnosticChartDialog,
	CloseHSSMisalagmentDiagnosticChartDialog,
	CloseRollingBearingDiagnosticChartDialog,
	GetWindDiagnosticTable,
	GetWindDiagnosticTableError,
	GetWindDiagnosticTableSuccess,
	OpenDiagnosticChartDialog,
	OpenHSSMisalagmentDiagnosticChartDialog,
	OpenRollingBearingDiagnosticChartDialog,
	OpenBrokenPinionStage2DiagnosticChartDialog,
	CloseBrokenPinionStage2DiagnosticChartDialog,
	OPEN_LOOSENESS_DIAGNOSTIC_DIALOG,
	CLOSE_LOOSENESS_DIAGNOSTIC_DIALOG,
	OPEN_PLANETARY_DIAGNOSTIC_DIALOG,
	CLOSE_PLANETARY_DIAGNOSTIC_DIALOG,
	OPEN_MAIN_SHAFT_UNBALANCE_DIALOG,
	CLOSE_MAIN_SHAFT_UNBALANCE_DIALOG,
	OPEN_MAIN_SHAFT_ANGULAR_MISALIGNMENT_DIALOG,
	CLOSE_MAIN_SHAFT_ANGULAR_MISALIGNMENT_DIALOG,
	OPEN_MAIN_SHAFT_PARALLEL_MISALIGNMENT_DIALOG,
	CLOSE_MAIN_SHAFT_PARALLEL_MISALIGNMENT_DIALOG,
	OPEN_ELECTRIC_FAIL_DIALOG,
	CLOSE_ELECTRIC_FAIL_DIALOG,
	OPEN_GEN_SHAFT_UNBALANCE_DIALOG,
	CLOSE_GEN_SHAFT_UNBALANCE_DIALOG,
} from "@/stores/actions/WindDiagnosticTable";

const state = {
	status:                                    FetchStatus.Init,
	reportStatus:                              FetchStatus.Init,
	resultSetStatus:                           FetchStatus.Init,
	data:                                      {},
	resultSetData:                             {},
	selectedResultSetElement:                  [],
	dialogParams:                              [],
	error:                                     {},
	isDialogOpen:                              false,
	isRollingBearingDialogOpen:                false,
	isHSSMisaligmentDialogOpen:                false,
	isBrokenTeethStage2DialogOpen:             false,
	isLoosenessDialogOpen:                     false,
	isPlanetaryDialogOpen:                     false,
	isMainShaftUnbalanceDialogOpen:            false,
	isMainShaftAngularMisalignmentDialogOpen:  false,
	isMainShaftParallelMisalignmentDialogOpen: false,
	isElectricFailDialogOpen:                  false,
	isGeneratorShaftUnbalanceDialogOpen:       false,
	dialogTitle:                               "",
	diagnosticLocation:                        "",
	reportData:                                {},
	reportTable:                               [],
	resultSetId:                               -1,
	isStage2:                                  false,
};

const Qs = require("qs");

const actions = {
	[GetWindDiagnosticTable]: ({ commit }, parameters) =>
	{
		commit(GetWindDiagnosticTable);
		http.get(`/WindTurbinesDiagnostic/${parameters.monitoringElementId}`, {
			params:           parameters,
			paramsSerializer: params => Qs.stringify(params,
				{ encode: false }),
		 })
			.then((resp) =>
			{
				commit(GetWindDiagnosticTableSuccess, resp.data);
			})
			.catch((error) =>
			{
				commit(GetWindDiagnosticTableError, error.response);
			});
	},

	[OpenDiagnosticChartDialog]: ({ commit }, param) =>
	{
		commit(OpenDiagnosticChartDialog, param);
	},

	[CloseDiagnosticChartDialog]: ({ commit }) =>
	{
		commit(CloseDiagnosticChartDialog);
	},

	[OpenRollingBearingDiagnosticChartDialog]: ({ commit }, param) =>
	{
		commit(OpenRollingBearingDiagnosticChartDialog, param);
	},

	[CloseRollingBearingDiagnosticChartDialog]: ({ commit }) =>
	{
		commit(CloseRollingBearingDiagnosticChartDialog);
	},

	[OpenHSSMisalagmentDiagnosticChartDialog]: ({ commit }, param) =>
	{
		commit(OpenHSSMisalagmentDiagnosticChartDialog, param);
	},

	[CloseHSSMisalagmentDiagnosticChartDialog]: ({ commit }) =>
	{
		commit(CloseHSSMisalagmentDiagnosticChartDialog);
	},
	[OpenBrokenPinionStage2DiagnosticChartDialog]: ({ commit }, params) =>
	{
		commit(OpenBrokenPinionStage2DiagnosticChartDialog, params);
	},
	[CloseBrokenPinionStage2DiagnosticChartDialog]: ({ commit }) =>
	{
		commit(CloseBrokenPinionStage2DiagnosticChartDialog);
	},
	[OPEN_LOOSENESS_DIAGNOSTIC_DIALOG]: ({ commit }, params) =>
	{
		commit(OPEN_LOOSENESS_DIAGNOSTIC_DIALOG, params);
	},
	[CLOSE_LOOSENESS_DIAGNOSTIC_DIALOG]: ({ commit }) =>
	{
		commit(CLOSE_LOOSENESS_DIAGNOSTIC_DIALOG);
	},
	[OPEN_PLANETARY_DIAGNOSTIC_DIALOG]: ({ commit }, params) =>
	{
		commit(OPEN_PLANETARY_DIAGNOSTIC_DIALOG, params);
	},
	[CLOSE_PLANETARY_DIAGNOSTIC_DIALOG]: ({ commit }) =>
	{
		commit(CLOSE_PLANETARY_DIAGNOSTIC_DIALOG);
	},

	[OPEN_MAIN_SHAFT_UNBALANCE_DIALOG]: ({ commit }, params) =>
	{
		commit(OPEN_MAIN_SHAFT_UNBALANCE_DIALOG, params);
	},
	[CLOSE_MAIN_SHAFT_UNBALANCE_DIALOG]: ({ commit }) =>
	{
		commit(CLOSE_MAIN_SHAFT_UNBALANCE_DIALOG);
	},

	[OPEN_MAIN_SHAFT_ANGULAR_MISALIGNMENT_DIALOG]: ({ commit }, params) =>
	{
		commit(OPEN_MAIN_SHAFT_ANGULAR_MISALIGNMENT_DIALOG, params);
	},
	[CLOSE_MAIN_SHAFT_ANGULAR_MISALIGNMENT_DIALOG]: ({ commit }) =>
	{
		commit(CLOSE_MAIN_SHAFT_ANGULAR_MISALIGNMENT_DIALOG);
	},

	[OPEN_MAIN_SHAFT_PARALLEL_MISALIGNMENT_DIALOG]: ({ commit }, params) =>
	{
		commit(OPEN_MAIN_SHAFT_PARALLEL_MISALIGNMENT_DIALOG, params);
	},
	[CLOSE_MAIN_SHAFT_PARALLEL_MISALIGNMENT_DIALOG]: ({ commit }) =>
	{
		commit(CLOSE_MAIN_SHAFT_PARALLEL_MISALIGNMENT_DIALOG);
	},

	[OPEN_ELECTRIC_FAIL_DIALOG]: ({ commit }, params) =>
	{
		commit(OPEN_ELECTRIC_FAIL_DIALOG, params);
	},
	[CLOSE_ELECTRIC_FAIL_DIALOG]: ({ commit }) =>
	{
		commit(CLOSE_ELECTRIC_FAIL_DIALOG);
	},
	[OPEN_GEN_SHAFT_UNBALANCE_DIALOG]: ({ commit }, params) =>
	{
		commit(OPEN_GEN_SHAFT_UNBALANCE_DIALOG, params);
	},
	[CLOSE_GEN_SHAFT_UNBALANCE_DIALOG]: ({ commit }) =>
	{
		commit(CLOSE_GEN_SHAFT_UNBALANCE_DIALOG);
	},
};

const mutations = {
	[GetWindDiagnosticTable]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},

	[GetWindDiagnosticTableSuccess]: (state, resp) =>
	{
		state.data = resp;
		state.status = FetchStatus.Loaded;
	},

	[GetWindDiagnosticTableError]: (state, error) =>
	{
		state.error = error.response;
		state.status = FetchStatus.Error;
	},

	[OpenDiagnosticChartDialog]: (state, param) =>
	{
		state.dialogParams = param;
		state.selectedResultSetElement = param.selectedResultSetElement;
		state.dialogTitle = param.title;
		state.diagnosticLocation = param.diagnosticLocation;
		state.isDialogOpen = true;
	},

	[CloseDiagnosticChartDialog]: (state) =>
	{
		state.dialogTitle = "";
		state.diagnosticLocation = "";
		state.dialogParams = "";
		state.isDialogOpen = false;
	},

	[OpenRollingBearingDiagnosticChartDialog]: (state, param) =>
	{
		state.dialogParams = param;
		state.isRollingBearingDialogOpen = true;
	},

	[CloseRollingBearingDiagnosticChartDialog]: (state) =>
	{
		state.dialogParams = "";
		state.isRollingBearingDialogOpen = false;
	},
	[OpenHSSMisalagmentDiagnosticChartDialog]: (state, param) =>
	{
		state.dialogParams = param;
		state.resultSetId = param.resultSetId;
		state.dialogTitle = param.title;
		state.diagnosticLocation = param.diagnosticLocation;
		state.isHSSMisaligmentDialogOpen = true;
	},

	[CloseHSSMisalagmentDiagnosticChartDialog]: (state) =>
	{
		state.dialogTitle = "";
		state.diagnosticLocation = "";
		state.dialogParams = "";
		state.resultSetId = -1;
		state.isHSSMisaligmentDialogOpen = false;
	},

	[OpenBrokenPinionStage2DiagnosticChartDialog]: (state, params) =>
	{
		state.dialogParams = params;
		state.selectedResultSetElement = params.selectedResultSetElement;
		state.dialogTitle = params.title;
		state.diagnosticLocation = params.diagnosticLocation;
		state.isBrokenTeethStage2DialogOpen = true;
		state.isStage2 = params.isStage2;
	},

	[CloseBrokenPinionStage2DiagnosticChartDialog]: (state) =>
	{
		state.isBrokenTeethStage2DialogOpen = false;
	},
	[OPEN_LOOSENESS_DIAGNOSTIC_DIALOG]: (state, params) =>
	{
		state.dialogParams = params;
		state.selectedResultSetElement = params.selectedResultSetElement;
		state.dialogTitle = params.title;
		state.diagnosticLocation = params.diagnosticLocation;
		state.isLoosenessDialogOpen = true;
	},

	[CLOSE_LOOSENESS_DIAGNOSTIC_DIALOG]: (state) =>
	{
		state.isLoosenessDialogOpen = false;
	},
	[OPEN_PLANETARY_DIAGNOSTIC_DIALOG]: (state, params) =>
	{
		state.dialogParams = params;
		state.selectedResultSetElement = params.selectedResultSetElement;
		state.dialogTitle = params.title;
		state.diagnosticLocation = params.diagnosticLocation;
		state.isPlanetaryDialogOpen = true;
	},

	[CLOSE_PLANETARY_DIAGNOSTIC_DIALOG]: (state) =>
	{
		state.isPlanetaryDialogOpen = false;
	},

	[OPEN_MAIN_SHAFT_UNBALANCE_DIALOG]: (state, param) =>
	{
		state.dialogParams = param;
		state.resultSetId = param.resultSetId;
		state.dialogTitle = param.title;
		state.diagnosticLocation = param.diagnosticLocation;
		state.isMainShaftUnbalanceDialogOpen = true;
	},

	[CLOSE_MAIN_SHAFT_UNBALANCE_DIALOG]: (state) =>
	{
		state.dialogTitle = "";
		state.diagnosticLocation = "";
		state.dialogParams = "";
		state.resultSetId = -1;
		state.isMainShaftUnbalanceDialogOpen = false;
	},

	[OPEN_MAIN_SHAFT_ANGULAR_MISALIGNMENT_DIALOG]: (state, param) =>
	{
		state.dialogParams = param;
		state.resultSetId = param.resultSetId;
		state.dialogTitle = param.title;
		state.diagnosticLocation = param.diagnosticLocation;
		state.isMainShaftAngularMisalignmentDialogOpen = true;
	},

	[CLOSE_MAIN_SHAFT_ANGULAR_MISALIGNMENT_DIALOG]: (state) =>
	{
		state.dialogTitle = "";
		state.diagnosticLocation = "";
		state.dialogParams = "";
		state.resultSetId = -1;
		state.isMainShaftAngularMisalignmentDialogOpen = false;
	},

	[OPEN_MAIN_SHAFT_PARALLEL_MISALIGNMENT_DIALOG]: (state, param) =>
	{
		state.dialogParams = param;
		state.resultSetId = param.resultSetId;
		state.dialogTitle = param.title;
		state.diagnosticLocation = param.diagnosticLocation;
		state.isMainShaftParallelMisalignmentDialogOpen = true;
	},

	[CLOSE_MAIN_SHAFT_PARALLEL_MISALIGNMENT_DIALOG]: (state) =>
	{
		state.dialogTitle = "";
		state.diagnosticLocation = "";
		state.dialogParams = "";
		state.resultSetId = -1;
		state.isMainShaftParallelMisalignmentDialogOpen = false;
	},

	[OPEN_ELECTRIC_FAIL_DIALOG]: (state, param) =>
	{
		state.dialogParams = param;
		state.resultSetId = param.resultSetId;
		state.dialogTitle = param.title;
		state.diagnosticLocation = param.diagnosticLocation;
		state.isElectricFailDialogOpen = true;
	},

	[OPEN_GEN_SHAFT_UNBALANCE_DIALOG]: (state, param) =>
	{
		state.dialogParams = param;
		state.resultSetId = param.resultSetId;
		state.dialogTitle = param.title;
		state.diagnosticLocation = param.diagnosticLocation;
		state.isGeneratorShaftUnbalanceDialogOpen = true;
	},

	[CLOSE_ELECTRIC_FAIL_DIALOG]: (state) =>
	{
		state.dialogTitle = "";
		state.diagnosticLocation = "";
		state.dialogParams = "";
		state.resultSetId = -1;
		state.isElectricFailDialogOpen = false;
	},

	[CLOSE_GEN_SHAFT_UNBALANCE_DIALOG]: (state) =>
	{
		state.dialogTitle = "";
		state.diagnosticLocation = "";
		state.dialogParams = "";
		state.resultSetId = -1;
		state.isGeneratorShaftUnbalanceDialogOpen = false;
	},
};

export default {
	state,
	actions,
	mutations,
};
